import { render, staticRenderFns } from "./OscillographyAnalysisAlarmsTab.vue?vue&type=template&id=75c84c19&"
import script from "./OscillographyAnalysisAlarmsTab.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisAlarmsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports